import '../../public/css/components/AppCenter/LoggedOutHeaderFooter.less';
import { clientLogger } from '../lib/logger';
import { getRankJsonString } from '../lib/fptiRecommendationHelper';
import { AMPLITUDE } from '../lib/constants';

const PARTNERS = 'partners';

const {
  AMPLITUDE_PRODUCT,
  AMPLITUDE_EVENT_PROPS,
  MAIN_IMPRESSION,
  CATEGORY_IMPRESSION,
  DETAIL_IMPRESSION
} = AMPLITUDE;

export const buildAppCenterVariables = (
  flatData,
  { detailsSlug, categorySlug }
) => {
  let tool;
  let category;
  let pgrp = 'main:merchanthub:appcenter';

  if (detailsSlug) {
    tool = Object.values(flatData.tools).find(
      ({ location }) => location === detailsSlug
    );
    if (tool) {
      pgrp += `:${tool.appFPTI}`;
    } else {
      clientLogger.warn('Tool not found for the detail slug', detailsSlug);
    }
  } else if (categorySlug) {
    category = Object.values(flatData.categories).find(
      ({ location }) => location === categorySlug
    );

    if (category) {
      pgrp += `:${category.categoryFPTI}`;
    } else {
      clientLogger.warn(
        'Category not found for the category slug',
        categorySlug
      );
    }
  } else {
    pgrp += `:main`;
  }

  return { tool, category, pgrp };
};
export const getCollectionFpti = options => {
  if (options?.type !== undefined) {
    return `:${options.type}`;
  }
  return '';
};
export const setAppCenterWindowFeedback = (tool, pgrp) => {
  // not server code . . .
  if (typeof window !== 'undefined') {
    // important for feedback fragment and ErrorBoundary, which needs access to global fpti data
    window.feedback = {
      pgrp,
      page: pgrp,
      ...(tool && { prod: tool.appFPTI })
    };
  }
};

export const getAppCategory = ({
  options,
  category,
  fptiLink,
  tool,
  pageLink
}) => {
  // get app_category
  if (category) {
    return category?.categoryKey || '';
  } else if (fptiLink === 'viewall') {
    // CategoryCard click
    return pageLink;
  } else if (fptiLink === 'get_started') {
    return tool?.categoryKey || '';
  } else if (options.category === 'parent') {
    // BreadCrumbs category click
    return fptiLink;
  }

  return '';
};

export const optObjAttrsForAmplitudeCommon = options => ({
  ...(options.amplitude && {
    product: AMPLITUDE_PRODUCT,
    event_props: AMPLITUDE_EVENT_PROPS,
    referrer: document?.referrer || ''
  })
});

export const optObjAttrsForAmplitude = ({
  options,
  category,
  fptiLink,
  tool,
  pageLink
}) => ({
  ...(options.amplitude && {
    ...optObjAttrsForAmplitudeCommon(options),
    event_name: options.event_name,
    app_category: getAppCategory({
      options,
      category,
      fptiLink,
      tool,
      pageLink
    })
  })
});

export const optObjAttrsFromOptions = options => ({
  // Sets other options attributes if applicable
  ...(options.prod && { prod: options.prod }),
  ...(options.category && { category: options.category }),
  ...(options.type && { type: options.type }),
  ...(options.utm_source && { utm_source: options.utm_source }),
  ...(options.utm_medium && { utm_medium: options.utm_medium }),
  ...(options.utm_content && { utm_content: options.utm_content }),
  ...(options.utm_campaign && { utm_campaign: options.utm_campaign }),
  ...(options.partner_name && { partner_name: options.partner_name })
});

export const optObjAttrsFromTool = tool => ({
  // every click on product detail pages gets prod: <product> field
  ...(tool && { prod: tool.appFPTI, rank: getRankJsonString(tool) })
});

export const optObjAttrsCategoryRank = options => ({
  // Add rank object to Tool Tile click event
  // This comes from Main Page Category/RFY rows and Category Page sections or tools
  ...(options.categoryRank && { rank: getRankJsonString(options) })
});

export const addlOptObjAttrsFptiClick = ({
  tool,
  options,
  pageLink,
  pathname,
  category,
  fptiLink
}) => ({
  // sets tools attributes
  ...optObjAttrsFromTool(tool),

  // sets category rank from options
  ...optObjAttrsCategoryRank(options),

  // Sets other options attributes if applicable
  ...optObjAttrsFromOptions(options),

  // add partner_name for all partner prod clicks on main and category pages
  ...(pageLink === PARTNERS && options.prod && { partner_name: options.prod }),

  // IF this is a details page for a partner . . .
  ...(tool && pathname.includes(PARTNERS) && { partner_name: tool.appFPTI }),

  //search options for app search in header
  ...(pageLink.includes('search') && {
    srch: options.srch || '',
    result: options.result || ''
  }),

  // sets amplitude attributes
  ...optObjAttrsForAmplitude({ options, category, fptiLink, tool, pageLink })
});

export const setAppCenterContainerAttributes = (
  container,
  { pageLink },
  isSearchModalEligible
) => {
  //search options for app search in header
  if (pageLink.includes('search')) {
    if (!container.page.includes('search')) {
      container.page = `${container.page}:${
        isSearchModalEligible ? 'search_modal' : 'search'
      }`;
    }
    if (!container.pgrp.includes('search')) {
      container.pgrp = `${container.pgrp}:${
        isSearchModalEligible ? 'search_modal' : 'search'
      }`;
    }
  }
};

export const getEventNameFptiImpression = (tool, category) => {
  if (tool) {
    return DETAIL_IMPRESSION;
  } else if (category) {
    return CATEGORY_IMPRESSION;
  }
  return MAIN_IMPRESSION;
};

export const overrideOptObjFptiImpression = (
  optionsObj,
  { options, detailsSlug, category, tool, pathname }
) => {
  // if and only if we navigate to a '/partners' details page
  if (detailsSlug && tool && pathname.includes('/partners')) {
    // add partner_name
    optionsObj.partner_name = tool.appFPTI;
  }

  if (options.amplitude) {
    optionsObj.event_name =
      options.event_name || getEventNameFptiImpression(tool);
    optionsObj.app_category = category?.categoryKey || tool?.categoryKey || '';
  }
};
